import React from 'react';
import {ExportButton} from './ExportButton';


export function LocationSidebarFocused({ getlocations, mapLocationClicked, unSelectLocation, addOpacityToColor }){
    const imageFallback = [
        'Automotive', 'Business', 'Community',
        'Education', 'Entertainment', 'Finance', 
        'Fitness', 'Food & Drink', 'Hotel',
        'Medical Institution', 'Rental Shop', 'Services', 
        'Shop', 'Sports & Outdoors', 'Supermarket',
        'Wellness and Beauty', 'Wellness and Health'
      ];
      
      // Get image source based on category
      const getImageSrc = () => {
        if (mapLocationClicked.Img) return mapLocationClicked.Img;
        const categoryName = mapLocationClicked.category !== "No Data" ? mapLocationClicked.category : mapLocationClicked.subcategory;

        return imageFallback.includes(categoryName) ? 
          `SegmentationIcons/${categoryName}.png` : 
          'SegmentationIcons/default.png';
      };
    const color = mapLocationClicked.custom ? 'grey' : getlocations.status_colors[mapLocationClicked.status] 
    return (
    <div className="m-20">
      <div 
        className="total-locations-sidebar" 
        style={{
          background: mapLocationClicked.custom ? '#ededed': addOpacityToColor(getlocations.status_colors[mapLocationClicked.status])
        }}
      >
        <div>{mapLocationClicked.custom ?          <div className='container-small-image'> <img 
            src={getImageSrc()}
            alt={mapLocationClicked.category}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'SegmentationIcons/default.png';
            }}
          /></div>: 
          <svg 
            width="18" 
            height="22" 
            viewBox="0 0 18 22" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.6201 7.45C16.5701 2.83 12.5401 0.75 9.0001 0.75C9.0001 0.75 9.0001 0.75 8.9901 0.75C5.4601 0.75 1.4201 2.82 0.370095 7.44C-0.799905 12.6 2.3601 16.97 5.2201 19.72C6.2801 20.74 7.6401 21.25 9.0001 21.25C10.3601 21.25 11.7201 20.74 12.7701 19.72C15.6301 16.97 18.7901 12.61 17.6201 7.45ZM9.0001 12.46C7.2601 12.46 5.8501 11.05 5.8501 9.31C5.8501 7.57 7.2601 6.16 9.0001 6.16C10.7401 6.16 12.1501 7.57 12.1501 9.31C12.1501 11.05 10.7401 12.46 9.0001 12.46Z"
              fill={mapLocationClicked.custom ? 'grey' : getlocations.status_colors[mapLocationClicked.status]}
            />
          </svg>
         }
        </div>
        <div>
          <div 
            className="name-locations-sidebar" 
            style={{
                paddingTop: mapLocationClicked.custom ? '0px' : '5px',
                color: color
            }}
          >
            {mapLocationClicked.name}
          </div>
          <div className="address-locations-sidebar">
            {mapLocationClicked.address}
          </div>
        </div>
        <button 
          className="current-locations-sidebar" 
          onClick={() => unSelectLocation()}
        >
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 20 20" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M10.0003 1.66675C5.40866 1.66675 1.66699 5.40841 1.66699 10.0001C1.66699 14.5917 5.40866 18.3334 10.0003 18.3334C14.592 18.3334 18.3337 14.5917 18.3337 10.0001C18.3337 5.40841 14.592 1.66675 10.0003 1.66675ZM12.8003 11.9167C13.042 12.1584 13.042 12.5584 12.8003 12.8001C12.6753 12.9251 12.517 12.9834 12.3587 12.9834C12.2003 12.9834 12.042 12.9251 11.917 12.8001L10.0003 10.8834L8.08366 12.8001C7.95866 12.9251 7.80033 12.9834 7.64199 12.9834C7.48366 12.9834 7.32533 12.9251 7.20033 12.8001C6.95866 12.5584 6.95866 12.1584 7.20033 11.9167L9.11699 10.0001L7.20033 8.08341C6.95866 7.84175 6.95866 7.44175 7.20033 7.20008C7.44199 6.95842 7.84199 6.95842 8.08366 7.20008L10.0003 9.11675L11.917 7.20008C12.1587 6.95842 12.5587 6.95842 12.8003 7.20008C13.042 7.44175 13.042 7.84175 12.8003 8.08341L10.8837 10.0001L12.8003 11.9167Z" 
              fill="#A4A7AE"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
